import { FullScreenContainer } from "@components/ui-kit";
import { useGetBrandForDocumentsQuery } from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/brands/page-loading";
import { BudgetPositionsSetsPage } from "@src/components/modules/budgets/positions-sets";
import { NotFoundBrand } from "@src/components/widgets/ErrorPage";
import { withCan } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";

interface PositionsSetsProps {
  /** Brand ID */
  id: string;
}

const PositionsSets = ({ id }: PositionsSetsProps) => {
  const { data, loading } = useGetBrandForDocumentsQuery({ variables: { id } });

  if (loading) {
    return <PageLoading brandId={id} />;
  }

  if (!data?.brand) {
    return <NotFoundBrand />;
  }

  return (
    <FullScreenContainer heightOffset="13rem">
      <BudgetPositionsSetsPage clientId={id} />
    </FullScreenContainer>
  );
};

export default withCan(
  { do: "integration_budgetovac" },
  observer(PositionsSets),
);
